import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { handleLegacyUrl } from "./lib/legacy-urls";

import { attachSupabaseAuthLazy } from "./lib/supabase-auth-attach";
// NOTE: the generated `attachSupabaseAuth` is intentionally NOT used here: it
// statically imports supabase-js (~200KB), which lands in the shared entry
// bundle of every page. `attachSupabaseAuthLazy` behaves identically but
// dynamically imports the client, so it is code-split and only fetched when a
// server function is actually called.

const errorMiddleware = createMiddleware().server(
  async ({ next, request }) => {
    // Internal email routes must not be wrapped by app middleware
    // (redirects, error pages, etc.).
    const url = new URL(request.url);
    if (url.pathname.startsWith("/lovable/")) {
      return next();
    }

    // Legacy WordPress URLs (attachment pages, wp-* infrastructure, old
    // permalinks). Return 301 to the modern page, or 410 Gone so crawlers
    // permanently drop the URL.
    const legacy = handleLegacyUrl(url);
    if (legacy) return legacy;


    try {
      return await next();
    } catch (error) {
      if (
        error != null &&
        typeof error === "object" &&
        "statusCode" in error
      ) {
        throw error;
      }
      console.error(error);
      return new Response(renderErrorPage(), {
        status: 500,
        headers: { "content-type": "text/html; charset=utf-8" },
      });
    }
  }
);

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuthLazy],
  requestMiddleware: [errorMiddleware],
}));
